import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { Flag } from "@obg/ngx.core.content";

@Component({
	selector: "obg-m-language-selector-menu",
	templateUrl: "./language-selector-menu.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorMenuComponent {
	@Input() flags: Flag[] | undefined;
	@HostBinding("class.obg-m-language-selector-menu") cssHostClass = true;

	trackByFlag(_index: number, flag: Flag) {
		return flag.id;
	}
}
